import { render, staticRenderFns } from "./OnboardingList.vue?vue&type=template&id=46e2bca9&"
import script from "./OnboardingList.vue?vue&type=script&lang=js&"
export * from "./OnboardingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports